import * as React from 'react'
import classNames from 'classnames'

import type { TableHeaderType } from '../../../types'
import style from './style.scss'

export type HeaderVariant = 'normal' | 'bold'

type Props = {
  className?: string
  columns: Array<TableHeaderType>
  variant?: HeaderVariant
}

function TableHead(props: Props) {
  const { columns, className, variant = 'normal' } = props

  return (
    <thead className={classNames(style.wrapper, style[variant], className)}>
      <tr>
        {columns.map(({ title, field }) => (
          <th key={field} className={classNames(style.wrapper, style[variant])}>
            {title}
          </th>
        ))}
      </tr>
    </thead>
  )
}

export default TableHead
